export default __webpack_public_path__ + "static/media/accessible_donors.7cc97210.png";